import { Placemark } from '@pbe/react-yandex-maps'
import { YMapsApi } from '@pbe/react-yandex-maps/typings/util/typing'
import { renderToString } from 'react-dom/server'

import { MapService } from '@/widgets/ShopsMapNew/assets/MapService'
import { Shop } from '@/widgets/ShopsMapNew/types/shop'

import { MapMarker } from '../../assets/MapMarker'
import { MapBalloon } from '../MapBaloon/MapBalloon'

interface ShopPlacemarkProps {
	shop: Shop
	onSelect: (shop: Shop) => void
	yMap: YMapsApi
	isActive: boolean
	isSelected: boolean
}

const getIconLayout = (shop: Shop, isSelected: boolean) =>
	renderToString(
		<>
			{shop.UF_IS_SERVICE === '1' && !isSelected && <MapService />}
			{shop.UF_IS_SERVICE === '1' && isSelected && <MapService color="#568DFE" />}
			{shop.UF_IS_SHOP === '1' && isSelected && <MapMarker color="#568DFE" />}
			{shop.UF_IS_SHOP === '1' && !isSelected && <MapMarker />}
		</>
	)

export const ShopPlacemark = (props: ShopPlacemarkProps) => {
	const { shop, isActive, onSelect, isSelected, yMap } = props
	const iconLayout = () => yMap?.templateLayoutFactory?.createClass(getIconLayout(shop, isSelected))

	const handleCardClick = (): void => {
		setTimeout(() => {
			onSelect(shop)
		}, 100)
	}
	return (
		<>
			<Placemark
				key={shop.NAME}
				geometry={[shop.GPS_N, shop.GPS_S]}
				onClick={handleCardClick}
				properties={{
					balloonContentBody: renderToString(<MapBalloon shop={shop} isVisible={isActive} />)
				}}
				options={{
					hideIconOnBalloonOpen: false,
					iconLayout: iconLayout(),
					iconOffset: [-12, -28],
					iconShape: {
						type: 'Rectangle',
						// @ts-ignore
						coordinates: [
							[0, 0],
							[28, 38]
						]
					},
					balloonOffset: [-90, 10],
					zIndex: 1,
					balloonAutoPanUseMapMargin: false,
					balloonAutoPanMargin: [0, 0]
				}}
				modules={[`geoObject.addon.hint`, `geoObject.addon.balloon`]}
			/>
		</>
	)
}
